import { Canonical } from "../common/common";
import { NEXT_FRONTEND_URL } from "@/src/lib/util/config";

const MetaTags = ({
    title,
    description,
    image,
    url,
    ogType = "website",
    twitterCard = "summary_large_image",
    siteName = "House of Diagnostics",
    locale = "en_US",
    additionalMeta = [],
}) => {
    // console.log("MetaTags -> title", url);

    return (
        <>
            <meta name="description" content={description} />
            <link rel="canonical" href={Canonical(url)} />
            {/* Open Graph Meta Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={ogType} />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:locale" content={locale} />

            {/* Twitter Meta Tags */}
            <meta name="twitter:card" content={twitterCard} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:url" content={url} />

            {/* Additional Meta Tags */}
            {additionalMeta.map((meta, index) => (
                <meta key={index} {...meta} />
            ))}
        </>
    );
};

export default MetaTags;
